<ng-container *ngIf="!isPirateShipEncryptedFlow; else encryptedRedirectOnly">
<div class="ccp-landing-wrapper">
  <div *ngIf="currentStep == 0">
    <ng-container *ngTemplateOutlet="welcomeTemplate"></ng-container>
  </div>
</div>
</ng-container>

<ng-template #encryptedRedirectOnly>
  <div class="landing-spinner" *ngIf="psEncryptedLandingSpinner">
    <div class="spinner-border" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
  <div class="error ml-2 mt-2" *ngIf="systemError">
    {{'common.systemError' | translate }}
  </div>
</ng-template>

<ng-template #welcomeTemplate>
  <form [formGroup]="customerForm">
    <div class="landing-top-block">
      <div class="custom-format" *ngIf="flowType !== 'pirateship'">
        <div class="landing-header">How to File a Claim</div>
        <hr *ngIf="!isMobile">
        <div class="divider-bar custom" *ngIf="isMobile"></div>
        <div class="landing-text">Gather your claim details and let's get started. Please make sure to complete the
          following four steps to file your claim:</div>
        <div>
          <img class="custom-width" src="../../../assets/images/ccp-blue-static-stepper.PNG" *ngIf="!isMobile">
        </div>
      </div>
      <div class="d-flex justify-content-center" *ngIf="flowType === 'pirateship'">
        <img src="../../../../assets/images/Insurehsield-Logo.png">
      </div>
    </div>
    <div class="mobile-image-format" *ngIf="flowType !== 'pirateship'">
      <img class="custom-width2" src="../../../assets/images/ccp-blue-static-stepper-vertical.PNG" *ngIf="isMobile">
    </div>
    <div class="landing-bottom-block">
      <div class="form-box">
        <div class="title" *ngIf="flowType !== 'pirateship'">Start a Claim</div>
        <div class="divider-bar" *ngIf="flowType !== 'pirateship'"></div>
        <div class="login-form d-flex flex-column pt-3" [ngClass]="{'greyBackground': !directUrl && flowType === 'pirateship'}">
          <ng-container *ngIf="!isLoading; else loadingSpinner">
            <div class="form-inputs" [ngClass]="{'pirateInput': flowType === 'pirateship' && !directUrl, 'd-flex justify-content-center': flowType === 'pirateship'}">
              <mat-form-field class="width-400" [ngClass]="{'pirateship-background': flowType === 'pirateship'}">
                <mat-label *ngIf="flowType !== 'pirateship'">{{'myChoice.howToFileAClaim.tracking' | translate
                  }}</mat-label>
                <mat-label *ngIf="flowType === 'pirateship' && !directUrl"
                  [ngClass]="{'headerText': !directUrl && flowType === 'pirateship'}">{{'myChoice.howToFileAClaim.pirateTracking'
                  |
                  translate}}</mat-label>
                <mat-label *ngIf="flowType === 'pirateship' && directUrl">{{'myChoice.howToFileAClaim.pirateTracking1' |
                  translate}}</mat-label>
                <input matInput formControlName="trackingNumber" [readonly]="flowType === 'pirateship' && !directUrl"
                  [disabled]="flowType === 'pirateship' && !directUrl">
                <mat-error *ngIf="customerForm.controls['trackingNumber'].errors">
                  <div *ngIf="customerForm.get('trackingNumber').errors?.required">
                    Tracking Number is required.
                  </div>
                </mat-error>
              </mat-form-field>
            </div>
            <!-- <div class="form-inputs" [ngClass]="{'pirateInput': flowType === 'pirateship' && !directUrl, 'd-flex justify-content-center': flowType === 'pirateship'}">
              <mat-form-field class="width-400" hideRequiredMarker>
                <mat-label [ngClass]="{'headerText': !directUrl && flowType === 'pirateship'}"> {{ flowType ===
                  'pirateship' && !directUrl ? 'Email Address (Pre-filled from Pirate Ship)' : 'Email Address'
                  }}</mat-label>
                <input matInput formControlName="email" [readonly]="flowType === 'pirateship' && !directUrl"
                  [disabled]="flowType === 'pirateship' && !directUrl"
                  [ngClass]="{'pirateInput': !directUrl && flowType === 'pirateship'}">
                <mat-error *ngIf="customerForm.controls['email'].errors">
                  <div *ngIf="customerForm.get('email').errors?.required">
                    Email Address is required.
                  </div>
                  <div *ngIf="customerForm.get('email').errors?.email">
                    Invalid Email Address.
                  </div>
                </mat-error>
              </mat-form-field>
            </div> -->
            <!-- <br> -->
            <div *ngIf="mustCompleteRecaptcha" [ngClass]="{'d-flex justify-content-center': flowType === 'pirateship'}"><re-captcha formControlName="recaptchaControl"></re-captcha></div>
          </ng-container>
          <ng-template #loadingSpinner>
            <div class="spinner d-flex justify-content-center">
              <div class="spinner-border">
              </div>
            </div>
          </ng-template>
          <div class="mt-4 terms-width" *ngIf="flowType !== 'pirateship'">
            <div class="d-flex flex-row checklist-format">
              <mat-checkbox class="blue-background-checkbox size-20" formControlName="terms"></mat-checkbox>
              <div class="ml-2 text">
                By clicking "Get Started" below, you acknowledge that you have read and agree to the
                <a href="https://www.insureshield.com/us/en/legal/technology-agreement.html" target="_blank"
                  rel="noopener noreferrer" class="upsc-link">UPS Capital Technology Agreement,</a>
                and you acknowledge the
                <a href="https://www.insureshield.com/us/en/legal/privacy-notice.html" target="_blank"
                  rel="noopener noreferrer" class="upsc-link">UPS Capital Privacy Notice.</a>
              </div>
            </div>
          </div>
          <div class="disclaimer">
            {{ 'login.form.captchaDisclaimer' | translate }}
          </div>
          <div class="buttons" [ngClass]="{'d-flex justify-content-center': flowType === 'pirateship'}">
            <button class="upsc-primary-button icon-right" [disabled]="customerForm.invalid" (click)="reCAPTCHA()" *ngIf="!loading"
              [ngClass]="{'pirateShipButton' : flowType === 'pirateship' && !customerForm.invalid}">
              Get Started
              <mat-icon class="mobile-format">keyboard_arrow_right</mat-icon>
            </button>
            <button class="upsc-primary-button icon-right" disabled *ngIf="loading"
            [ngClass]="{'pirateShipButton' : flowType === 'pirateship' && !loading}">
              Get Started<span class="spinner-border"></span>
            </button>
            <!-- <button class="next-step loading d-flex align-items-center justify-content-between" *ngIf="loading"
              [ngClass]="{'pirateShipButton' : flowType === 'pirateship' && !loading}">
              <div>Get Started</div>
              <div class="spinner-border" role="status">
                <span class="sr-only">{{ 'claims.edit.loading' | translate }}</span>
              </div>
            </button> -->
          </div>

          <!-- View My Filed Claims link for PirateShip -->
          <div class="mt-3" *ngIf="flowType === 'pirateship'">
            <div class="d-flex justify-content-center">
              <button type="button" (click)="viewMyFiledClaims(); $event.preventDefault(); $event.stopPropagation();"
                [disabled]="!customerForm.get('recaptchaControl')?.value"
                style="color: #0662BB; text-decoration: underline; background: none; border: none; padding: 0; font: inherit; cursor: pointer; box-shadow: none; outline: none;"
                [style.opacity]="(!customerForm.get('recaptchaControl')?.value) ? '0.5' : '1'">
                {{'myChoice.howToFileAClaim.pirateViewClaims' | translate}}
              </button>
            </div>
          </div>

          <div [ngClass]="{'d-flex justify-content-center': flowType === 'pirateship'}">

            <div class="error mt-2" *ngIf="systemError">
              {{'common.systemError' | translate }}
            </div>
            <div class="error mt-2" *ngIf="duplicateTrackingNumber">
              A claim has already been filed using this tracking number.
            </div>
            <div class="error mt-2" *ngIf="policyMatchError">
              This shipment is not covered under {{channelPartnerDisplayName}} policies.
            </div>
            <div class="error mt-2" *ngIf="shipmentInformationError">
              Shipment information was incomplete. We are unable to process a claim on this tracking number.
            </div>
            <div class="error mt-2" *ngIf="isInsuredValueZero && flowType !== 'pirateship'">
              Oops! Shipment is not covered under your shipping protection solution, please file claim directly with
              Carrier.
            </div>
            <div class="error mt-2" *ngIf="liabilityError && flowType !== 'pirateship'">
              Oops! Shipment is not covered under your shipping protection solution, please file claim directly with
              Carrier.
            </div>
            <div class="error mt-2" *ngIf="liabilityError && flowType === 'pirateship'">
              Oops! There was an unexpected error filing your claim. Please contact insureshieldsupport@ups.com with the
              relevant tracking number to troubleshoot your issue or claim.
            </div>
            <div class="error mt-2" *ngIf="upsHealthCareDeclaredAmountError">
              Oops! This shipment is not covered under your shipping protection solution, please file claim directly
              with
              UPS at <a href="https://www.ups.com" target="_blank" class="upsc-link">www.ups.com</a>
            </div>
            <div class="error mt-2" *ngIf="trackingNumberNotFound && flowType !== 'pirateship'">
              Oops! Shipment is not covered under your shipping protection solution, please file claim directly with
              Carrier.
            </div>
            <div class="error mt-2" *ngIf="trackingNumberNotFound && flowType === 'pirateship'">
              Oops! There was an unexpected error filing your claim. Please contact insureshieldsupport@ups.com with the
              relevant tracking number to troubleshoot your issue or claim.
            </div>
            <div class="error mt-2" *ngIf="invalidTrackingNumber">
              This Tracking Number is not covered under this policy please use a different Tracking Number.
            </div>
            <div class="error mt-2" *ngIf="shipDateError && flowType === 'pirateship'">
              Oops! This package was shipped prior to the Policy Coverage Date. Please contact support@pirateship.com to
              proceed with your claim.
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</ng-template>
